<template>
  <div>
    <!-- SUCCESS MESSAGE -->

    <div v-if="successMessage" class="alert alert-success">
      <i class="bi bi-check-circle"></i>
      {{ successMessage }}
    </div>

    <!-- ERROR MESSAGE -->

    <div v-if="errorMessage" class="alert alert-danger">
      <i class="bi bi-exclamation-triangle"></i>
      {{ errorMessage }}
    </div>

    <!-- NORMAL PREVIEW -->

    <div v-if="!editMode" class="p-3 border-bottom">
      <h6 class="fw-bold mb-3 text-white">
        <i class="bi bi-eye"></i>
        Current Content Preview
      </h6>

      <!-- VIDEO -->

      <div v-if="content.main_video" class="ratio ratio-16x9 mb-3">
        <iframe
          :src="youtubeEmbed(content.main_video)"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>

      <div v-else class="text-secondary small mb-3">No video added yet</div>

      <!-- MESSAGE -->

      <p class="text-light">
        {{ content.founder_message || "No founder message yet." }}
      </p>

      <button class="btn btn-primary btn-sm" @click="enableEdit">
        <i class="bi bi-pencil"></i>
        Edit
      </button>
    </div>

    <!-- EDIT MODE -->

    <div v-if="editMode" class="p-3 border-bottom">
      <h6 class="fw-bold mb-3 text-white">
        <i class="bi bi-pencil"></i>
        Edit Content
      </h6>

      <form @submit.prevent="saveHome">
        <!-- VIDEO INPUT -->

        <div class="mb-3">
          <label class="form-label">YouTube Video Link</label>

          <input type="text" class="form-control" v-model="form.main_video" />

          <!-- VIDEO PREVIEW -->

          <div v-if="form.main_video" class="ratio ratio-16x9 mt-3">
            <iframe
              :src="youtubeEmbed(form.main_video)"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>

          <div v-else class="text-secondary small mt-2">No video added yet</div>
        </div>

        <!-- MESSAGE -->

        <div class="mb-3">
          <label class="form-label">Founder Message</label>

          <textarea
            class="form-control"
            rows="4"
            v-model="form.founder_message"
          ></textarea>
        </div>

        <!-- BUTTONS -->

        <button
          type="button"
          class="btn btn-secondary me-2"
          @click="cancelEdit"
        >
          Cancel
        </button>

        <button class="btn btn-success" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm"></span>

          <span v-else> <i class="bi bi-save"></i> Save </span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HomeContent",

  data() {
    return {
      editMode: false,
      loading: false,

      successMessage: "",
      errorMessage: "",

      content: {
        main_video: "",
        founder_message: "",
      },

      form: {
        main_video: "",
        founder_message: "",
      },
    };
  },

  mounted() {
    this.getContent();
  },

  methods: {
    enableEdit() {
      this.editMode = true;

      this.form.main_video = this.content.main_video;
      this.form.founder_message = this.content.founder_message;
    },

    cancelEdit() {
      this.editMode = false;
    },

    youtubeEmbed(url) {
      if (!url) return "";

      let id = url;

      if (url.includes("watch?v=")) {
        id = url.split("watch?v=")[1];
      }

      if (url.includes("youtu.be/")) {
        id = url.split("youtu.be/")[1];
      }

      return `https://www.youtube.com/embed/${id}`;
    },

    getContent() {
      axios.get("/home-content").then((res) => {
        if (res.data) this.content = res.data;
      });
    },

    saveHome() {
      this.loading = true;
      this.successMessage = "";
      this.errorMessage = "";

      axios
        .post("/save-home-content", this.form)

        .then(() => {
          this.successMessage = "Content updated successfully";

          this.editMode = false;

          this.getContent();
        })

        .catch(() => {
          this.errorMessage = "Something went wrong. Please try again.";
        })

        .finally(() => {
          this.loading = false;

          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, 4000);
        });
    },
  },
};
</script>
